document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initProducto();
  initUso();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var run = function (el) {
    var target = parseFloat(el.getAttribute('data-mt-countup'));
    var suffix = el.getAttribute('data-mt-suffix') || '';
    if (prefersReduced || isNaN(target)) {
      el.textContent = target + suffix;
      return;
    }
    var duration = 1400;
    var start = null;
    var step = function (ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1);
      el.textContent = value + suffix;
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  if (!('IntersectionObserver' in window)) {
    els.forEach(run);
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        run(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initUso() {
  var grupos = document.querySelectorAll('[data-mt-uso]');
  if (!grupos.length) return;

  grupos.forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-mt-uso-btn]');

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('mt-uso-paso-activo'); });
        btn.classList.add('mt-uso-paso-activo');
      });
    });
  });
}

function initProducto() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root) return;

  var dataEl = root.querySelector('[data-mt-variantes]');
  var variantes = [];
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { variantes = []; }

  var idInput = root.querySelector('[data-mt-variant-id]');
  var precioEl = root.querySelector('[data-mt-precio]');
  var precioAntesEl = root.querySelector('[data-mt-precio-antes]');
  var ahorroEl = root.querySelector('[data-mt-ahorro]');
  var stockEl = root.querySelector('[data-mt-stock]');
  var submitBtn = root.querySelector('[data-mt-submit]');
  var agotadoEl = root.querySelector('[data-mt-agotado]');
  var opciones = root.querySelectorAll('[data-mt-opcion]');
  var precioMovilEl = document.querySelector('[data-mt-precio-movil]');
  var precioAntesMovilEl = document.querySelector('[data-mt-precio-antes-movil]');
  var comprarMovilBtn = document.querySelector('[data-mt-comprar-movil]');

  if (comprarMovilBtn) {
    comprarMovilBtn.addEventListener('click', function () {
      if (submitBtn) submitBtn.click();
    });
  }

  var thumbs = root.querySelectorAll('[data-mt-thumb]');
  var principal = root.querySelector('[data-mt-imagen-principal]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('mt-thumb-activo'); });
      thumb.classList.add('mt-thumb-activo');
      if (principal) {
        principal.src = thumb.getAttribute('data-mt-full');
      }
    });
  });

  if (!opciones.length) return;

  function seleccionActual() {
    var seleccion = {};
    opciones.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-valor-activo');
      if (activo) seleccion[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-mt-valor');
    });
    return seleccion;
  }

  function encontrarVariante(seleccion) {
    return variantes.find(function (v) {
      return Object.keys(seleccion).every(function (k) { return v.opciones[k] === seleccion[k]; });
    });
  }

  function actualizar() {
    var seleccion = seleccionActual();
    var variante = encontrarVariante(seleccion);
    if (!variante) return;

    if (idInput) idInput.value = variante.id;
    if (precioEl) precioEl.textContent = variante.precio;
    if (precioMovilEl) precioMovilEl.textContent = variante.precio;
    if (precioAntesEl) {
      if (variante.precioAntes) {
        precioAntesEl.textContent = variante.precioAntes;
        precioAntesEl.style.display = '';
      } else {
        precioAntesEl.style.display = 'none';
      }
    }
    if (precioAntesMovilEl) {
      if (variante.precioAntes) {
        precioAntesMovilEl.textContent = variante.precioAntes;
        precioAntesMovilEl.style.display = '';
      } else {
        precioAntesMovilEl.style.display = 'none';
      }
    }
    if (ahorroEl) {
      if (variante.ahorro) {
        ahorroEl.textContent = 'Ahorras ' + variante.ahorro + '%';
        ahorroEl.style.display = '';
      } else {
        ahorroEl.style.display = 'none';
      }
    }
    if (stockEl) {
      if (variante.stock) {
        stockEl.textContent = '🔥 Quedan solo ' + variante.stock + ' unidades';
        stockEl.style.display = '';
      } else {
        stockEl.style.display = 'none';
      }
    }

    var disponible = variante.disponible;
    if (submitBtn) submitBtn.style.display = disponible ? '' : 'none';
    if (agotadoEl) agotadoEl.style.display = disponible ? 'none' : '';
    if (comprarMovilBtn) comprarMovilBtn.style.display = disponible ? '' : 'none';

    if (variante.imagen && principal) {
      principal.src = variante.imagen;
      thumbs.forEach(function (t) {
        t.classList.toggle('mt-thumb-activo', t.getAttribute('data-mt-full') === variante.imagen);
      });
    }
  }

  opciones.forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-mt-valor]');
    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('mt-valor-activo'); });
        btn.classList.add('mt-valor-activo');
        actualizar();
      });
    });
  });

  actualizar();
}
